// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"_pages-dir-browser_node_modules_next_dist_pages__error_js":"232435d83e0330e8","_pages-dir-browser_node_modules_next_dist_pages__app_js":"5ef9ab0deef66390","_pages-dir-browser_src_providers_FeatureFlagProvider_tsx":"8ef55235d1723f00"}[chunkId] + ".js";
};